/** @format */

export const formProps = {
	// 尺寸 ['medium ', 'small', 'mini']
	size: {
		type: String,
		validator: sizeValidator,
	},
	// 是否在一行
	inline: {
		type: Boolean,
		default: false,
	},
	// 文本的宽度
	labelWidth: {
		type: Number,
		default: 75,
	},
	labelSuffix: {
		type: String,
		default: '：',
	},
	// 输入框的宽度
	itemWidth: {
		type: Number,
		default: 100,
	},
	// 异步数据
	fuzzy: {
		type: Boolean,
		default: false,
	},
	// 表单
	forms: {
		type: Array,
		required: true,
	},
	// 是否选择器
	selector: {
		type: Boolean,
		default: false,
	},
};

function sizeValidator(value) {
	const methodTypes = ['medium ', 'small', 'mini'];
	const valid = methodTypes.indexOf(value.toLowerCase()) !== -1 || value === '';
	if (!valid) {
		throw new Error(`Size must be one of ['medium ', 'small', 'mini']`);
	}
	return valid;
}
